/* eslint-disable import/prefer-default-export */
import axios from 'axios';

const getExhibitions = async () => {
  const token = localStorage.getItem('token');
  if (!token) return null;
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/exhibitions`,
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return data;
};

export {
  getExhibitions,
};
